import { render } from "./ActivateCertificate.vue?vue&type=template&id=7bf8556e&scoped=true"
import script from "./ActivateCertificate.vue?vue&type=script&lang=js"
export * from "./ActivateCertificate.vue?vue&type=script&lang=js"

import "./ActivateCertificate.vue?vue&type=style&index=0&id=7bf8556e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bf8556e"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QDialog});qInstall(script, 'directives', {ClosePopup});
